/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-named-as-default
import Dashboard from "layouts/dashboard";
// import XrayPictures from "layouts/xray_pictures";
// import Users from "layouts/users";
// import Customers from "layouts/customers";
// import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Document from "examples/Icons/Document";
// import CustomerSupport from "examples/Icons/CustomerSupport";
// import CreditCard from "examples/Icons/CreditCard";
import Orders from "layouts/orders";
// import Drugs from "layouts/drugs";
import Transactions from "layouts/transactions";
import BackUpData from "layouts/back_up";
// import Expenses from "layouts/expenses";
import TestUsers from "layouts/users/test";
import Totals from "layouts/totals/totals";
import Customers from "layouts/customers";
import Containers from "layouts/containers";
import AllOrders from "layouts/all_orders";
import Posts from "layouts/posts";
import Messages from "layouts/messages";
import Status from "layouts/status";
import CustomerOrders from "layouts/customer_orders";
import AllOrdersCustomers from "layouts/all_orders_customers";

// import { useTranslation } from "react-i18next";

// eslint-disable-next-line no-unused-vars
// const { t } = useTranslation();
const CustomerRoutes = [
  {
    type: "collapse",
    name: "Messages",
    key: "messages",
    route: "/messages",
    icon: <Office size="12px" />,
    component: <Messages />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Customer Orders",
    key: "customer_orders",
    route: "/customer_orders",
    icon: <Office size="12px" />,
    component: <CustomerOrders />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Customer Order Details",
    key: "customer_order_details",
    route: "/customer_order_details",
    icon: <Office size="12px" />,
    component: <AllOrdersCustomers />,
    noCollapse: true,
  },
];

export default CustomerRoutes;
